/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer } from '../runtime.js';

const cs_phone_number = /** @type {(inputs: {}) => string} */ () => {
	return `Telefonní číslo`
};

const da_phone_number = /** @type {(inputs: {}) => string} */ () => {
	return `Telefonnummer`
};

const de_phone_number = /** @type {(inputs: {}) => string} */ () => {
	return `Telefonnummer`
};

const en_phone_number = /** @type {(inputs: {}) => string} */ () => {
	return `Phone number`
};

const es_phone_number = /** @type {(inputs: {}) => string} */ () => {
	return `Número de teléfono`
};

const fr_phone_number = /** @type {(inputs: {}) => string} */ () => {
	return `Numéro de téléphone`
};

const hu_phone_number = /** @type {(inputs: {}) => string} */ () => {
	return `Telefonszám`
};

const it_phone_number = /** @type {(inputs: {}) => string} */ () => {
	return `Numero di telefono`
};

const nl_phone_number = /** @type {(inputs: {}) => string} */ () => {
	return `Telefoonnummer`
};

const pl_phone_number = /** @type {(inputs: {}) => string} */ () => {
	return `Numer telefonu`
};

const pt_phone_number = /** @type {(inputs: {}) => string} */ () => {
	return `Número de telefone`
};

const sv_phone_number = /** @type {(inputs: {}) => string} */ () => {
	return `Telefonnummer`
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "cs" | "da" | "de" | "en" | "es" | "fr" | "hu" | "it" | "nl" | "pl" | "pt" | "sv" }} options
* @returns {string}
*/
/* @__NO_SIDE_EFFECTS__ */
export const phone_number = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.phone_number(inputs) 
	}
	const locale = options.locale ?? getLocale()
	trackMessageCall("phone_number", locale)
	if (locale === "cs") return cs_phone_number(inputs)
	if (locale === "da") return da_phone_number(inputs)
	if (locale === "de") return de_phone_number(inputs)
	if (locale === "en") return en_phone_number(inputs)
	if (locale === "es") return es_phone_number(inputs)
	if (locale === "fr") return fr_phone_number(inputs)
	if (locale === "hu") return hu_phone_number(inputs)
	if (locale === "it") return it_phone_number(inputs)
	if (locale === "nl") return nl_phone_number(inputs)
	if (locale === "pl") return pl_phone_number(inputs)
	if (locale === "pt") return pt_phone_number(inputs)
	return sv_phone_number(inputs)
};